import safety from "../assets/safety.png";
import face from "../assets/faceai.png";
import dressfit from "../assets/dressfit.png";
import news from "../assets/newsai.png";
import health from "../assets/healthai.png";
import docscan from "../assets/docsanai.png";
import parking from "../assets/parking.png";
import speed from "../assets/speedai.png";
import wagon from "../assets/wagonai.png";

const products = [
  {
    id: 1,
    title: "Safety.AI",
    text: "AI-driven safety system that detects PPE, tracks movement, and alerts for unsafe activities instantly.",
    video: safety,
  },
  {
    id: 2,
    title: "Face.AI",
    text: "Facial recognition technology enabling secure access control and accurate attendance tracking for organizations.",
    video: face,
  },
  {
    id: 3,
    title: "DressFit.AI",
    text: "Upload an outfit to preview real-time virtual fitting, posture simulation, and realistic texture visualization.",
    video: dressfit,
  },
  {
    id: 4,
    title: "News.AI",
    text: "Intelligent AI news anchor delivering stories with natural expressions, gestures, and engaging lifelike narration.",
    video: news,
  },
  {
    id: 5,
    title: "Health.AI",
    text: "Predictive healthcare model analyzing medical images to detect diseases early and assist clinical research.",
    video: health,
  },
  {
    id: 6,
    title: "DocScan.AI",
    text: "Smart OCR engine that extracts text, names, and key data from documents and ID cards precisely.",
    video: docscan,
  },
  {
    id: 7,
    title: "Parking.AI",
    text: "Vision-based parking solution that detects empty slots, guides vehicles, and monitors occupancy in real time.",
    video: parking,
  },
  {
    id: 8,
    title: "Speed.AI",
    text: "AI vision tool tracking vehicle speed, identifying violators, and generating automated number plate reports.",
    video: speed,
  },
  {
    id: 9,
    title: "Wagon.AI",
    text: "Automated system identifying wagons, counting cargo, detecting residues, and monitoring railway operations efficiently.",
    video: wagon,
  },
];

export default products;
